import getOne from 'utils/getOne'
import { filterRoles } from 'consts'

const loadRecord = async (url: string, id: number | string) => {
  const retData = await getOne(url, id).then((data) => {
    const loadedData = {
      ...data,
      role: data?.role?.toLowerCase(),
    }

    return loadedData
  })

  if (retData?.role) {
    retData.role = filterRoles.find(role => role.value === retData.role)
  }

  return retData
}

export default loadRecord
